(() => {
  function initialize(root) {
    if (root.dataset.cgReady) return;
    const controls = root.querySelector('[data-cg-controls]');
    const list = root.querySelector('[data-cg-products]');
    if (!controls || !list) return;
    const items = Array.from(list.children);
    const buttons = Array.from(controls.querySelectorAll('[data-category-filter]'));
    const sortButtons = Array.from(controls.querySelectorAll('[data-sort-filter]'));
    const available = controls.querySelector('[data-cg-available]');
    const availableCount = controls.querySelector('[data-cg-available-count]');
    const refinements = controls.querySelector('[data-cg-refinements]');
    const count = root.querySelector('[data-cg-count]');
    const empty = root.querySelector('[data-cg-empty]');
    if (!available || !count || !empty || !buttons.length || !sortButtons.length) return;
    const resultCount = count.querySelector('[data-cg-result]');
    const totalCount = count.querySelector('[data-cg-total]');
    const conditionText = count.querySelector('[data-cg-conditions]');
    root.dataset.cgReady = 'true';
    let category = 'all';
    let sort = 'default';
    const categoryLabels = { all: 'すべて', wallet: '財布・革小物', bag: '鞄・バッグ', other: 'その他' };
    const sortLabels = { default: '掲載順', 'price-asc': '価格の安い順', 'price-desc': '価格の高い順' };
    const materialFilters = [
      {
        field: 'leather',
        buttonKey: 'leatherFilter',
        selector: '[data-leather-filter]',
        labels: { all: '革すべて', torrillon: 'トリヨンシュリンク', matt: 'マットシュリンク' }
      },
      {
        field: 'interior',
        buttonKey: 'interiorFilter',
        selector: '[data-interior-filter]',
        labels: { all: '内装すべて', nume: 'ヌメ革', bridle: 'ブライドルレザー', mattone: 'マットーネ', fabric: '生地の内装', none: '内装なし', other: 'その他' }
      },
      {
        field: 'finish',
        buttonKey: 'finishFilter',
        selector: '[data-finish-filter]',
        labels: { all: '加工すべて', plain: '通常の仕上げ', pressed: 'プレス加工' }
      }
    ].map(filter => {
      filter.buttons = Array.from(controls.querySelectorAll(filter.selector));
      filter.enabled = filter.buttons.length > 0 && items.some(item => Boolean(item.dataset[filter.field]));
      filter.value = 'all';
      filter.buttons.forEach(button => {
        const group = button.closest('[role="group"]');
        if (group) group.hidden = !filter.enabled;
        const key = button.dataset[filter.buttonKey];
        button.hidden = key !== 'all' && !items.some(item => item.dataset[filter.field] === key);
        button.setAttribute('aria-pressed', String(key === 'all'));
        button.addEventListener('click', () => {
          filter.value = key;
          filter.buttons.forEach(candidate => candidate.setAttribute('aria-pressed', String(candidate === button)));
          update();
        });
      });
      return filter;
    });
    if (refinements) refinements.hidden = !materialFilters.some(filter => filter.enabled);
    const facetButtons = buttons.map(button => ({ button, field: 'category', value: button.dataset.categoryFilter }));
    materialFilters.forEach(filter => {
      filter.buttons.forEach(button => facetButtons.push({ button, field: filter.field, value: button.dataset[filter.buttonKey] }));
    });
    facetButtons.forEach(option => {
      let node = option.button.querySelector('[data-cg-option-count]');
      if (!node) {
        node = document.createElement('small');
        node.setAttribute('data-cg-option-count', '');
        option.button.appendChild(node);
      }
      option.count = node;
    });
    buttons.forEach(button => {
      const key = button.dataset.categoryFilter;
      button.hidden = key !== 'all' && !items.some(item => item.dataset.category === key);
      button.addEventListener('click', () => {
        category = key;
        buttons.forEach(candidate => candidate.setAttribute('aria-pressed', String(candidate === button)));
        update();
      });
    });
    sortButtons.forEach(button => {
      button.addEventListener('click', () => {
        sort = button.dataset.sortFilter;
        sortButtons.forEach(candidate => candidate.setAttribute('aria-pressed', String(candidate === button)));
        update();
      });
    });
    function matches(item, excludedFacet) {
      return (excludedFacet === 'category' || category === 'all' || item.dataset.category === category)
        && (excludedFacet === 'available' || !available.checked || item.dataset.available === 'true')
        && materialFilters.every(filter => !filter.enabled || filter.field === excludedFacet || filter.value === 'all' || item.dataset[filter.field] === filter.value);
    }
    function update() {
      let visible = 0;
      const ordered = items.slice();
      if (sort !== 'default') {
        const direction = sort === 'price-asc' ? 1 : -1;
        ordered.sort((a, b) => (Number(a.dataset.price) - Number(b.dataset.price)) * direction);
      }
      ordered.forEach(item => {
        item.hidden = !matches(item);
        if (!item.hidden) visible += 1;
        list.appendChild(item);
      });
      // Preview switching this facet while retaining every other selection.
      facetButtons.forEach(option => {
        const matching = items.filter(item => matches(item, option.field) && (option.value === 'all' || item.dataset[option.field] === option.value)).length;
        option.count.textContent = `(${matching})`;
      });
      if (availableCount) {
        const matching = items.filter(item => matches(item, 'available') && item.dataset.available === 'true').length;
        availableCount.textContent = `(${matching})`;
      }
      const conditions = [categoryLabels[category]];
      materialFilters.forEach(filter => {
        if (filter.enabled) conditions.push(filter.labels[filter.value]);
      });
      conditions.push(available.checked ? '在庫あり' : '在庫指定なし', sortLabels[sort]);
      if (resultCount && totalCount && conditionText) {
        resultCount.textContent = String(visible);
        totalCount.textContent = String(items.length);
        conditionText.textContent = conditions.join(' / ');
      } else {
        count.textContent = `${conditions.join(' / ')} — ${visible}件 / 全${items.length}件`;
      }
      empty.hidden = visible > 0;
    }
    available.addEventListener('change', update);
    controls.hidden = false;
    update();
  }
  function scan() { document.querySelectorAll('[data-cm-collection-guide]').forEach(initialize); }
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
